var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useEffect, useState, } from 'react';
import classNames from 'classnames';
import { mergeRefs } from './mergeRefs';
import { usePreviousIsOpen } from './usePreviousIsOpen';
export var Collapse = React.forwardRef(function (_a, ref) {
    var className = _a.className, isOpen = _a.isOpen, onRest = _a.onRest, children = _a.children, rest = __rest(_a, ["className", "isOpen", "onRest", "children"]);
    var internalRef = useRef(null);
    var _b = useState(!isOpen), isHidden = _b[0], setIsHidden = _b[1];
    var _c = useState(isOpen), overflowVisible = _c[0], setOverflowVisible = _c[1];
    var previousIsOpen = usePreviousIsOpen(isOpen);
    useEffect(function () {
        if (typeof previousIsOpen === 'boolean' &&
            isOpen !== previousIsOpen) {
            setIsHidden(!isOpen);
            setOverflowVisible(false);
        }
    }, [previousIsOpen, isOpen]);
    return (React.createElement("div", __assign({}, rest, { ref: mergeRefs([internalRef, ref]), className: classNames('ffe-collapse', className, {
            'ffe-collapse--open': isOpen,
            'ffe-collapse--hidden': isHidden,
        }), onTransitionEnd: function (e) {
            if (e.target === internalRef.current &&
                e.propertyName === 'grid-template-rows') {
                setIsHidden(!isOpen);
                if (isOpen) {
                    setOverflowVisible(true);
                }
                onRest === null || onRest === void 0 ? void 0 : onRest();
            }
        } }),
        React.createElement("div", { className: classNames('ffe-collapse__inner', {
                'ffe-collapse__inner--visible': overflowVisible,
            }) }, children)));
});
